import SvgIcon from '@/pages/home/components/SvgIcon';
import React from 'react';
import './index.scss';

export default function StarNum() {
  const getNumberStar = (num: number) => {
    let elements = [];
    for (let index = 0; index < num; index++) {
      elements.push(<SvgIcon key={index} type="star-action" />);
    }

    return elements;
  };

  return (
    <div className="dbo-scorebox-starbox">
      {[5, 4, 3, 2, 1].map((item) => (
        <div className="dbo-scorebox-starline" key={item}>
          {getNumberStar(item)}
        </div>
      ))}
    </div>
  );
}
